import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import { steps } from "../utils/stepsConfig";
import { useStep } from "../hooks/useStep";
import { useShoppingCart } from "../hooks/useShoppingCart";
import { pagesToHideProgressBarOn } from '../utils/hideProgressBarConfig'
import "../styles/progressBar.css";

const ProgressBar = () => {
    const { t } = useTranslation();
    const { stepData } = useStep();
    const { subscription, addons, formValues } = useShoppingCart();
    
    const navigate = useNavigate();
    const location = useLocation();

    const currentStepIndex = steps.findIndex(step => step.path === location.pathname);
    const totalSteps = steps.length;
    const progress = (currentStepIndex / (totalSteps - 1)) * 100;

    // Combine all state for validation
    const stepState = {
        subscription,
        addons,
        formValues,
        ...stepData
    };

    const currentStep = steps[currentStepIndex];
    const isStepValid = currentStep?.validate
        ? currentStep?.validate(stepState)
        : true;

    const handleNext = () => {
        if (!isStepValid) return;
        if (currentStepIndex < totalSteps - 1) {
            navigate(steps[currentStepIndex + 1].path);
        }
    };

    const handleBack = () => {
        if (currentStepIndex > 0) {
            navigate(steps[currentStepIndex - 1].path);
        }
    };

    // console.log('pagesToHideProgressBarOn',pagesToHideProgressBarOn)
    // console.log('location.pathname',location.pathname)
    if (pagesToHideProgressBarOn.includes(location.pathname)) {
        return null;
    }

    return (
        <div className="progress-container">
            <div className="progress-track">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
            </div>

            <div className="progress-controls">
                <button
                    onClick={handleBack}
                    disabled={currentStepIndex <= 0 || currentStepIndex === totalSteps - 1}
                    className="btn btn-primary"
                >
                    {t('back')}
                </button>

                <button
                    onClick={handleNext}
                    disabled={currentStepIndex >= totalSteps - 1 || !isStepValid}
                    className="btn btn-primary"
                >
                    {t('next')}
                </button>
            </div>
        </div>
    );
};

export default ProgressBar;